<template>
  <div>
    <div class="content-header">
      <div class="left">
        <DatePicker type="daterange" @on-change="dateChange" v-model="date" placeholder="选择时间"
        style="width: 200px"></DatePicker>
        <Input placeholder="搜索序列号、站点" style="width: 200px;margin: 0 0 1px 5px" search enter-button="搜索" @on-search="search"/>
        <Button style="margin-left: 5px" @click="init()">重置</Button>
      </div>
      <div class="right">
        <Button type="primary" v-preventReClick @click="preResult">一键结算</Button>
      </div>
    </div>
    <div style="margin-bottom: 8px;color: #ff9900">注: 未选择抄表结算方案,无法选择</div>
    <table cellspacing="0" cellpadding="0" border="0" class="meter-table">
      <thead>
        <tr>
          <th style="text-align:center;padding: 0 5px"><input type="checkbox" v-model="checkAll" @click="checkBox(false,$event)"></th>
          <th>设备型号</th>
          <th>设备序列号</th>
          <th>设备站点</th>
          <th>抄表类型</th>
          <th>上次结算截止</th>
          <th>本次结算开始</th>
          <th>本次结算截止</th>
          <!-- <th>其他费用</th>
          <th>补充说明</th> -->
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in machine" :key="index" v-if="item.times.length > 1">
          <td style="text-align:center;padding: 0 5px">
            <input type="checkbox" v-model="item.check" @click="checkBox(item)" :disabled="item.meter_charge_id?false:true">
          </td>
          <td>{{item.machine_type_name}}</td>
          <td>{{item.sn}}</td>
          <td>{{item.site_name}}</td>
          <td>{{item.meter?item.meter===1?'智能运维':'手工抄表':"云知印"}}</td>
          <td>{{item.last_time?$moment(item.last_time):"本次为第一次结算"}}</td>
          <td>
            <!-- 开始 -->
            <!-- <Select @on-change="setTime($event,item,'start')" style="width: 135px">
              <Option :class="{date_use: it.is_result?true:false}" v-for="(it,ind) in item.times" :value="it.id" :key="ind">
                {{$moment(it.create_time)}}
              </Option>
            </Select> -->
            <Select v-model="item.start.id" style="width: 160px" @on-change="dateSelectChange(item,$event,'start')">
              <Option :class="{date_use: it.is_result?true:false}" v-for="(it,ind) in item.times"
              :value="it.id" :key="`start_${ind}`">
                {{$moment(it.create_time)}}
              </Option>
            </Select>
          </td>
          <td>
            <!-- 结束 -->
            <!-- <Select @on-change="setTime($event,item,'end')" style="width: 135px" :disabled="item.start_time?false:true">
              <Option :class="{date_use: it.is_result?true:false}" v-for="(it,ind) in item.times" :value="it.id" :key="ind" :disabled="new Date(item.start_time).getTime()>=new Date(it.create_time).getTime()?true:false">{{$moment(it.create_time)}}</Option>
            </Select> -->
            <Select v-model="item.end.id" style="width: 160px" @on-change="dateSelectChange(item,$event,'end')">
              <Option :class="{date_use: it.is_result?true:false}" v-for="(it,ind) in item.times"
              :value="it.id" :key="`end_${ind}`"
              :disabled="new Date(item.start.create_time).getTime()>=new Date(it.create_time).getTime()?true:false">
                {{$moment(it.create_time)}}
              </Option>
            </Select>
          </td>
          <!-- <td><InputNumber :active-change="false" :precision="2" :max="1000" :min="0" :step="0.1" v-model="item.money"/></td>
          <td><Input v-model="item.log" placeholder="补充说明..."/></td> -->
          <td><Button type="primary" size="small" @click="otherInfo(item)">其他</Button></td>
        </tr>
      </tbody>
    </table>
    <Drawer :title="drawer.title" v-model="drawer.visible" width="400px" :mask-closable="true"
    :styles="drawer.styles" :mask-style="drawer.mask">
      <Form ref="formInline" :model="drawer.data" :rules="rule" :label-width="100">
        <FormItem label="其他费用:">
          <InputNumber style="width: 80%" :active-change="false" :precision="2" :min="0" :step="0.1" v-model="drawer.data.money"/>
        </FormItem>
        <FormItem label="费用描述:">
          <Input style="width: 80%" type="textarea" v-model="drawer.data.money_log" placeholder="费用描述"/>
        </FormItem>
        <FormItem label="备注说明:">
          <Input style="width: 80%" type="textarea" v-model="drawer.data.log" placeholder="备注说明"/>
        </FormItem>
      </Form>
      <div class="drawer-footer">
        <Button @click="drawer.visible = false" style="margin-right:10px">取消</Button>
        <Button type="primary" @click="setOtherInfo">确定</Button>
      </div>
      <!-- <InputNumber :active-change="false" :precision="2" :min="0" :step="0.1" v-model="drawer.data.money"/>
      <Input v-model="drawer.data.total_log" placeholder="补充说明..."/> -->
    </Drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      machine: [],
      checkList: {},
      checkAll: false,
      date: '',
      drawer: {
        data: {},
        visible: false,
        styles: {
          height: 'calc(100% - 55px)',
          overflow: 'auto',
          paddingBottom: '53px',
          position: 'static'
        },
        mask: {
          background: 'transparent'
        }
      },
      rule: {}
    }
  },
  mounted () {
    let now = new Date()
    this.date = [
      this.$moment(now, 'YYYY') + '-01-01',
      this.$moment(now, 'YYYY') + `-12-31`
    ]
    this.init()
  },
  methods: {
    otherInfo (data) {
      this.drawer.data = JSON.parse(JSON.stringify(data))
      this.drawer.visible = true
    },
    setOtherInfo () {
      this.machine.map((item, index) => {
        if (item.id === this.drawer.data.id) {
          this.$set(item, 'money', this.drawer.data.money)
          this.$set(item, 'money_log', this.drawer.data.money_log)
          this.$set(item, 'log', this.drawer.data.log)
        }
      })
      this.drawer.visible = false
    },
    search (text) {
      try {
        let temp = []
        this.machine.map(item => {
          if ((item.site_name && item.site_name.indexOf(text) >= 0) || item.sn.indexOf(text) >= 0) {
            temp.push(item)
          }
        })
        this.machine = temp
      } catch (error) {
        console.log(error)
      }
    },
    dateSelectChange (data, value, type) {
      let current = {}
      data.times.map(item => {
        if (item.id === value) {
          current = JSON.parse(JSON.stringify(item))
        }
      })
      data[type] = current
      if (new Date(data.start.create_time).getTime() >= new Date(data.end.create_time).getTime()) {
        data.end = {}
      }
    },
    dateChange (value) {
      this.date = value
      this.init()
    },
    preResult () {
      let flag = true,
        list = []
      // console.log(this.machine)
      this.machine.map(item => {
        if (item.check && (!item.start.id || !item.end.id)) {
          flag = item.sn
        } else if (item.check) {
          list.push(item)
        }
      })
      if (flag === true) {
        this.getMeterCharge(list)
      } else {
        this.$Message.error(`${flag}设备未选择结算开始或截止时间`)
      }
    },
    getMeterCharge (list) {
      let charge_ids = []
      list.map(item => {
        charge_ids.push(item.meter_charge_id)
      })
      this.GetMeterChargesByMachineId({ ids: charge_ids.join(',') }).then(res => {
        console.log(133, res)
        res.map(item => {
          list.map(it => {
            if (item.id === it.meter_charge_id) {
              this.makeResult(item, it)
              // TODO 暂时屏蔽
              this.$router.push({ name: 'meter-order' })
            }
          })
        })
      })
    },
    makeResult (charge, row) {
      let data = {
        agent_id: this.user.id,
        machine_id: row.machine_id,
        meter_start_id: row.start.id,
        meter_end_id: row.end.id,
        meter_charge_id: row.meter_charge_id,
        money: row.money,
        log: row.log,
        money_log: row.money_log
      }
      let rule = JSON.parse(charge.content)
      console.log(155, rule)
      let result_money = 0,
        total = row.end.total - row.start.total,
        black_num = row.end.black_num - row.start.black_num,
        color_num = row.end.color_num - row.start.color_num,
        black_a3_num = row.end.black_a3_num - row.start.black_a3_num,
        color_a3_num = row.end.color_a3_num - row.start.color_a3_num,
        both_num = row.end.both_num - row.start.both_num
      console.log({ total, black_num, color_num, black_a3_num, color_a3_num, both_num })
      switch (charge.type) {
        case 1:
          black_num = black_num - rule.black_num
          color_num = color_num - rule.color_num
          if (black_num < 0) { black_num = 0 };
          if (color_num < 0) { color_num = 0 };
          result_money = black_num * rule.black_money + color_num * rule.color_money
          break
        case 2:
          black_num = black_num - rule.black_num
          color_num = color_num - rule.color_num
          let lines2 = ['a', 'b', 'c']
          lines2.map(line => {
            if (rule.black[line].t !== -1 && rule.black[line].t <= black_num) {
              result_money += (rule.black[line].t - rule.black[line].f + 1) * rule.black[line].money
            } else if (rule.black[line].t === -1) {
              result_money += (black_num - rule.black[line].f + 1) * rule.black[line].money
            }
            if (rule.color[line].t !== -1 && rule.color[line].t <= color_num) {
              result_money += (rule.color[line].t - rule.color[line].f + 1) * rule.color[line].money
            } else if (rule.color[line].t === -1 && (color_num > rule.color[line].f)) {
              result_money += (color_num - rule.color[line].f + 1) * rule.color[line].money
            }
          })
          break
        case 3:
          black_num = black_num - rule.black_num
          color_num = color_num - rule.color_num
          let lines3 = ['c', 'b', 'a'],
            flag_black = true,
            flag_color = true
          lines3.map(line => {
            if (black_num >= rule.black[line].m && flag_black) {
              result_money += black_num * rule.black[line].money
              flag_black = false
            }
            if (color_num >= rule.color[line].m && flag_color) {
              result_money += color_num * rule.color[line].money
              flag_color = false
            }
          })
          break
        case 4:
          let black_a4_num = black_num - 2 * black_a3_num,
            color_a4_num = color_num - 2 * color_a3_num
          let temp_list = []
          temp_list.push((black_a3_num - rule.blackA3Num) * rule.blackA3Money)
          temp_list.push((black_a4_num - rule.blackA4Num) * rule.blackA4Money)
          temp_list.push((color_a3_num - rule.colorA3Num) * rule.colorA3Money)
          temp_list.push((color_a4_num - rule.colorA4Num) * rule.colorA4Money)
          temp_list.push((both_num - rule.bothNum) * rule.bothMoney)
          temp_list.map(item => {
            if (item < 0) {
              item = 0
            }
            result_money += item
          })
          break
        case 5:
          let sizes = ['a3', 'a4'],
            liens5 = ['a', 'b', 'c'],
            colors = ['black', 'color']
          var numObj = {
            black_a4_num: black_num - 2 * black_a3_num - rule.blackA4Num,
            color_a4_num: color_num - 2 * color_a3_num - rule.colorA4Num,
            black_a3_num: black_a3_num - rule.blackA3Num,
            color_a3_num: color_a3_num - rule.colorA3Num,
            both_num: both_num - rule.bothNum
          }
          var temp_list = []
          colors.map(color => {
            sizes.map(size => {
              liens5.map(line => {
                if (rule[color][size][line].t !== -1 && rule[color][size][line].t <= numObj[`${color}_${size}_num`]) {
                  temp_list.push((rule[color][size][line].t - rule[color][size][line].f + 1) * rule[color][size][line].money)
                } else if (rule[color][size][line].t === -1) {
                  temp_list.push((numObj[`${color}_${size}_num`] - rule[color][size][line].f + 1) * rule[color][size][line].money)
                }
              })
            })
          })
          liens5.map(line => {
            if (rule.both[line].t !== -1 && rule.both[line].t <= numObj.both_num) {
              temp_list.push((rule.both[line].t - rule.both[line].f + 1) * rule.both[line].money)
            } else if (rule.both[line].t === -1) {
              temp_list.push((numObj.both_num - rule.both[line].f + 1) * rule.both[line].money)
            }
          })
          temp_list.map(item => {
            if (item > 0) {
              result_money += item
            }
          })
          break
        case 6:
          var numObj = {
            black_a4_num: black_num - 2 * black_a3_num - rule.blackA4Num,
            color_a4_num: color_num - 2 * color_a3_num - rule.colorA4Num,
            black_a3_num: black_a3_num - rule.blackA3Num,
            color_a3_num: color_a3_num - rule.colorA3Num,
            both_num: both_num - rule.bothNum
          }
          let lines6 = ['c', 'b', 'a'],
            colors6 = ['black', 'color'],
            sizes6 = ['a4', 'a3']
          var flag = {
            black_a3_flag: true,
            black_a4_flag: true,
            color_a3_flag: true,
            color_a4_flag: true,
            both_flag: true
          }
          colors6.map(color => {
            sizes6.map(size => {
              lines6.map(line => {
                if (numObj[`${color}_${size}_num`] >= rule[color][size][line].m && flag[`${color}_${size}_flag`]) {
                  result_money += numObj[`${color}_${size}_num`] * rule[color][size][line].money
                  flag[`${color}_${size}_flag`] = false
                }
                if (numObj.both_num >= rule.both[line].m && flag.both_flag) {
                  result_money += numObj.both_num * rule.both[line].money
                  flag.both_flag = false
                }
              })
            })
          })
          break
      }
      data.total = data.money + charge.basics + result_money
      console.log(290, data)
      // TODO 暂时屏蔽
      this.PutMeterResult(data).then(res => {
        if (res) {
          this.$Message.success(`设备:${row.sn},结算完成`)
        }
      })
    },
    checkBox (row, e) {
      if (row) {
        row.check = !row.check
      } else {
        this.machine.map(item => {
          if (item.meter_charge_id) {
            item.check = e.target.checked
          }
        })
      }
    },
    init () {
      this.GetMeterOrderMachine({
        start: this.$moment(this.date[0], 'YYYY-MM-DD'),
        end: this.$moment(this.date[1], 'YYYY-MM-DD')
      }).then(res => {
        let ids = []
        res.map(item => {
          item.times = []
          item.start_time = ''
          item.end_time = ''
          item.check = false
          item.money = 0
          item.log = ''
          item.last_time = ''
          item.start = {}
          item.end = {}

          ids.push(item.machine_id)
        })
        this.machine = res

        this.GetAgentMeter({
          start: this.$moment(this.date[0], 'YYYY-MM-DD'),
          end: this.$moment(this.date[1], 'YYYY-MM-DD')
        }).then(re => {
          this.machine.map((item, index) => {
            re.map(it => {
              if (it.machine_id === item.machine_id) {
                item.times.push(it)
              }
            })
          })
          this.setStartAndEnd()
        })
        this.GetLastMeter({ ids: ids.join(',') }).then(r => {
          console.log(348, r)
          this.machine.map(item => {
            r.map(it => {
              if (item.machine_id === it.machine_id) {
                item.last_time = it.end_time
              }
            })
          })
        })
      })
    },
    setStartAndEnd () {
      let data = JSON.parse(JSON.stringify(this.machine))
      data.map((item, index) => {
        let start = {}
        item.times.map(item => {
          console.log(363, item)
          if (item.is_result) {
            start = item
            // flag = false;
          }
        })
        if (!start.id) {
          start = item.times[0]
        }
        item.start = JSON.parse(JSON.stringify(start))
        item.end = JSON.parse(JSON.stringify(item.times[item.times.length - 1]))
      })
      this.machine = data
    },
    ...mapActions(['GetMeterOrderMachine', 'GetAgentMeter', 'GetMeterChargesByMachineId', 'PutMeterResult', 'GetLastMeter'])
  },
  computed: mapGetters({
    user: 'agent'
  })
}
</script>

<style lang="less">
  @import './index.less';
</style>
